export default [
    {
        name: 'chatRecord',
        title: '结果反馈'
    },
    {
        name: 'add',
        title: '添加微信'
    }
]



// WEBPACK FOOTER //
// ./src/route/robotPhoneRoute.js